import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from "@/shared/hooks";
import { Dropdown } from "@gemini/ui";
import { Controller } from "react-hook-form";
import { workStatusTestId } from "./constants";
import { useDropdownItems } from "./useDropdownItems";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
export const WorkStatusInput = ({ control }) => {
    const { t } = useI18n();
    const isPreviewMode = useIsPreviewMode();
    const defaultItems = useDropdownItems("contact.form.work_status_items", 10);
    return (_jsx(Controller, { name: "workStatus", control: control, defaultValue: "", render: ({ fieldState: { error }, field }) => (_jsx(Dropdown, Object.assign({}, (error && {
            error: t("contact.form.work_status_error_empty"),
        }), field, { defaultValue: "", label: t("contact.form.work_status"), placeholder: t("contact.form.please_select"), testId: workStatusTestId, defaultItems: defaultItems, isDisabled: isPreviewMode }))) }));
};
